import * as React from 'react';
import { Link } from 'react-router';

import Pagination from "react-js-pagination";

import NewsCategory from '../../api/newsCategoryEntity';
import NewsItemDto from '../../api/newsItemDto';
import NewsItem from '../../api/newsItemEntity';

import { BreadcrumbContainer } from '../../common/components/breadcrumb/breadcrumbContainer';

interface IProps {
    categoriesFilter: string;
    newsCategories: NewsCategory[];
    newsItemDto: NewsItemDto;
    fetchArchivePageNews(query?: object): void;
    fetchNewsCategories(): void;
    fetchArchivePageNewsItemsByCategory(categories: string, query?: object): void;
}

export class ArchiveNewsPage extends React.Component<IProps,{itemsOnPage: number, isItemsRecieved: boolean}> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isItemsRecieved: false,
            itemsOnPage: 15
        };

        this.handlePageChange = this.handlePageChange.bind(this);
    }

  public componentDidMount() {
    this.props.fetchNewsCategories();
    // this.props.fetchArchivePageNews({limit: this.state.itemsOnPage});
  }

  public componentWillReceiveProps (nextProps: IProps) {
    if(nextProps.categoriesFilter !== this.props.categoriesFilter || !this.state.isItemsRecieved) {
        if (nextProps.newsCategories.length !== 0 && !this.state.isItemsRecieved) {
            this.setState({
                isItemsRecieved: true
            })
        }

        if (!nextProps.categoriesFilter) {
            this.props.fetchArchivePageNews({limit: this.state.itemsOnPage});
            return;
        }

        const propertyToEquel = "/" + nextProps.categoriesFilter;

        nextProps.newsCategories.forEach(element => {
            if (propertyToEquel === element.friendlyUrl) {
                this.props.fetchArchivePageNewsItemsByCategory(element.id, {limit: this.state.itemsOnPage});
                return;
            }
        });
    }
 }

 public handlePageChange = (pageNumber: number) => {
    const skipItems = this.state.itemsOnPage * pageNumber - this.state.itemsOnPage;

    if(this.props.categoriesFilter) {
        const propertyToEquel = "/" + this.props.categoriesFilter;

        this.props.newsCategories.forEach(element => {
            if (propertyToEquel === element.friendlyUrl) {
                this.props.fetchArchivePageNewsItemsByCategory(element.id, {limit: this.state.itemsOnPage, skip: skipItems});
                return;
            }
        });
    } else {
        this.props.fetchArchivePageNews({limit: this.state.itemsOnPage, skip: skipItems});
    }
}

  public render() {
      let cssClassName = "";

      if (window.location.href.indexOf("ajankohtaista/") === -1) {
          cssClassName = "active";
      }

    return (
        <main className="contentpage">
            <div className="container">

                <BreadcrumbContainer />

                <div className="row">
                    <div className="col-md-12 col-sm-12">
                        <h1>Kaikki uutiset</h1>
                        <div className="categories">
                            <b>Suodata aiheen mukaan</b>
                            <div className="categories-list">
                                <ul id="taglist">
                                    <li><Link className={cssClassName} to={"/uutiset/ajankohtaista"}>Kaikki</Link></li>
                                    {this.props.newsCategories && this.props.newsCategories.map(NewsCategoryItem)}
                                </ul>
                            </div>

                       </div>
                        <ul className="newslisting">
                        {this.props.newsItemDto.newsItems.map(ArchiveNewsItem)}
                        </ul>
                        <Pagination
                            activePage={this.props.newsItemDto.skip / this.state.itemsOnPage + 1}
                            itemsCountPerPage={this.props.newsItemDto.limit}
                            totalItemsCount={this.props.newsItemDto.total}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                            />
                    </div>
                </div>
            </div>
        </main>
    );
  }
};

const ArchiveNewsItem = (newsItem: NewsItem) => {
    return (
        <li>
            <Link to={`/uutiset${newsItem.id}`} className="box-inner-wrap" tabIndex={-1}>{newsItem.title}</Link>
        </li>
    )
  }

  const NewsCategoryItem = (newsCategory: NewsCategory) => {
      let cssClassName = "";

      if (window.location.href.indexOf(newsCategory.friendlyUrl) !== -1) {
          cssClassName = "active";
      }
    return (
      <li>
        <Link className={cssClassName} to={`/uutiset/ajankohtaista${newsCategory.friendlyUrl}`}>{newsCategory.title}</Link>
      </li>
    )
  }


// WEBPACK FOOTER //
// ./src/components/archiveNewsPage/archiveNewsPage.tsx